export default {
  title: "Clés Architect",
  caption: "Jetons MCP pour Claude Code et les agents",
  menuTitle: "Gérer les clés",
  superadmin: {
    badge: "Superadmin",
    badgeTitle:
      "Clé globale — peut appeler des outils globaux (ex. ajouter au catalogue MCP) en plus des outils du tenant.",
    label: "Clé superadmin (globale)",
    hint: "Permet à cette clé d'appeler des outils globaux comme l'ajout d'entrées au catalogue MCP, en plus des outils de ce tenant. Réservé au super admin.",
  },
  common: {
    copy: "Copier",
    suggest: "suggérer",
  },
  connect: {
    title: "Le plus simple — se connecter avec son compte",
    subtitle:
      "Aucune clé à copier. Ajoutez un connecteur dans votre application IA, puis connectez-vous avec votre compte habituel.",
    step1:
      "Dans votre application IA, ouvrez {path} (Claude Desktop, ChatGPT, Le Chat, et d'autres). Laissez vides les champs « OAuth Client ID / Secret ».",
    step1Path: "Paramètres → Connecteurs → Ajouter un connecteur personnalisé",
    chooseTools: "Choisissez les outils à connecter :",
    pasteAddress: "Collez cette adresse :",
    step3:
      "Cliquez sur {action} et connectez-vous. Approuvez une fois — les outils apparaissent alors dans votre application.",
    connectAction: "Connecter",
    safety:
      "Elle peut lire et {suggest} des changements — jamais les appliquer. Vous approuvez chaque changement ici, dans l'application.",
  },
  keys: {
    titleOauth: "Clés d'accès",
    titleNoOauth: "Connectez votre assistant IA",
    descOauth:
      "Pour les outils en ligne de commande et les scripts (Claude Code, cron, CI) — partout où il n'y a pas de navigateur pour se connecter. Une clé peut lire et {suggest} des changements ; jamais les appliquer.",
    descNoOauth:
      "Créez une clé d'accès pour connecter les outils de ce hub à Claude Desktop, ChatGPT, Gemini, Le Chat et d'autres. Une clé peut lire et {suggest} des changements — elle ne peut jamais les appliquer. Vous approuvez toujours ici, dans l'application.",
    newButton: "Nouvelle clé d'accès",
    empty: {
      title: "Aucune clé d'accès pour l'instant",
      body: "Créez une clé et nous vous montrerons exactement comment la connecter à votre application IA — Claude Desktop, ChatGPT, Gemini, Le Chat et d'autres. La clé n'est affichée qu'une seule fois à la création, copiez-la avant de fermer.",
    },
    table: {
      name: "Nom",
      prefix: "Préfixe",
      scopes: "Portées",
      status: "Statut",
      lastUsed: "Dernière utilisation",
      expires: "Expire",
      actions: "Actions",
    },
    status: {
      active: "Active",
      expired: "Expirée",
      revoked: "Révoquée",
    },
  },
  relative: {
    never: "jamais",
    justNow: "à l'instant",
    minutesAgo: "il y a {n} min",
    hoursAgo: "il y a {n} h",
    daysAgo: "il y a {n} j",
  },
  actions: {
    rotate: "Renouveler la clé",
    revoke: "Révoquer la clé",
  },
  create: {
    title: "Créer une clé d'accès",
    description:
      "La clé est affichée une seule fois à l'écran suivant — copiez-la avant de fermer.",
    usageLabel: "Où allez-vous l'utiliser ?",
    usagePlaceholder: "Choisissez l'application ou l'appareil…",
    usageHint:
      "Nous l'utilisons pour nommer la clé afin que vous puissiez la reconnaître plus tard.",
    labelLabel: "Libellé",
    labelPlaceholder: "Portable de Jean",
    labelHint:
      "Affiché dans cette liste et dans les journaux d'audit. Modifiez-le si vous le souhaitez.",
    ttlLabel: "Durée de vie (jours)",
    ttlHint: "90 par défaut. Maximum 365.",
    cancel: "Annuler",
    generate: "Générer",
  },
  usage: {
    myLaptop: "Mon ordinateur portable",
    other: "Autre",
  },
  issued: {
    title: "Votre clé est prête — copiez-la maintenant",
    description:
      "C'est la seule fois où la clé est affichée. Choisissez votre application ci-dessous et suivez les étapes. Le hub ne stocke jamais qu'une empreinte à sens unique.",
    safeTitle: "Sûre par conception",
    safeBody:
      "Cette clé peut lire et suggérer des changements — elle ne peut jamais les appliquer. Vous approuvez toujours ici, dans l'application.",
    whichApp: "Quelle application utilisez-vous ?",
    whichTools: "Quels outils ?",
    download: "Télécharger {filename}",
    rawSummary: "Seulement la clé d'accès (pour tout autre client)",
    copyKey: "Copier la clé",
    closingTitle: "Fermer cette fenêtre masque la clé définitivement.",
    closingBody:
      "Le hub ne stocke jamais qu'une empreinte à sens unique. Si vous la perdez, révoquez-la et créez-en une nouvelle.",
    done: "Terminé",
  },
  servers: {
    aiemployee: "Outils AI Employee",
    care: "Outils Care",
    lms: "Outils LMS",
    marketresearch: "Outils Étude de Marché",
  },
  clients: {
    "claude-desktop": {
      label: "Claude Desktop",
      where:
        "Menu Claude → Réglages → Développeur → Modifier la configuration. Collez ceci dans le fichier, puis quittez complètement et rouvrez Claude Desktop.",
      note: "Nécessite Node.js installé (le pont s'exécute via npx). Les versions récentes de Claude Desktop peuvent aussi ajouter un connecteur par URL sans clé — voir l'onglet URL.",
    },
    "cursor-vscode": {
      label: "Cursor / VS Code",
      where:
        "Cursor → ~/.cursor/mcp.json. VS Code → .vscode/mcp.json dans votre projet. Fusionnez ceci dans le fichier.",
    },
    gemini: {
      label: "Gemini CLI",
      where:
        "Gemini CLI → ~/.gemini/settings.json. Fusionnez ceci dans le fichier.",
      note: "L'application web/mobile Gemini se connecte par une étape de connexion plutôt qu'avec une clé collée — voir l'onglet URL.",
    },
    "claude-code": {
      label: "Claude Code",
      where: "Exécutez ceci dans votre terminal.",
    },
    chatgpt: {
      label: "ChatGPT",
      where:
        "Paramètres → Connecteurs → Ajouter un connecteur personnalisé (mode Développeur) → collez cette URL et connectez-vous lorsque demandé.",
      note: "ChatGPT se connecte en se connectant, pas avec une clé collée. Utilisez l'URL ; s'il demande une clé d'accès, collez le jeton du bas de cette fenêtre.",
    },
    "le-chat": {
      label: "Le Chat (Mistral)",
      where:
        "Le Chat → Connecteurs → Ajouter un connecteur → collez cette URL et connectez-vous lorsque demandé.",
      note: "Le Chat se connecte en se connectant, pas avec une clé collée. Utilisez l'URL ; s'il demande une clé d'accès, collez le jeton du bas de cette fenêtre.",
    },
    other: {
      label: "Autre",
      where:
        "La plupart des clients MCP acceptent une URL de serveur plus un en-tête Authorization. Utilisez cette configuration, ou l'URL brute + le jeton ci-dessous.",
    },
  },
  dialogs: {
    rotateTitle: "Renouveler {name} ?",
    rotateMessage:
      "Génère une clé de remplacement et donne à celle-ci une expiration de grâce de 14 jours pour changer les configurations sans interruption. Le nouveau jeton est affiché une seule fois à l'écran suivant.",
    revokeTitle: "Révoquer {name} ?",
    revokeMessage:
      "C'est synchrone — le prochain appel MCP avec ce jeton échouera. La ligne reste pour l'audit mais la clé est morte immédiatement.",
  },
  toasts: {
    addressCopied: "Adresse copiée — collez-la dans votre application IA.",
    keyCopiedConfig: "Copié — collez maintenant dans votre configuration MCP.",
    snippetCopied: "Copié — collez-le dans votre application IA.",
    downloaded:
      "{filename} téléchargé — ouvrez-le dans la configuration de votre application IA.",
    revoked: "Révoquée.",
  },
};
